<!-- Loader -->
<div *ngIf="isLoading" class="flex justify-center items-center h-64">
  <i class="fas fa-spinner fa-spin text-5xl text-yellow-500"></i>
</div>

<!-- Summary Cards -->
<div *ngIf="!isLoading" class="p-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">

  <!-- Total Orders -->
  <div class="bg-gradient-to-r from-yellow-100 to-yellow-50 shadow-md rounded-2xl p-6 border-l-8 border-yellow-500 hover:shadow-lg transition-all duration-300">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-gray-600 text-sm uppercase font-semibold">Total Orders</h3>
        <p class="text-4xl font-bold text-gray-900 mt-1">{{ summary?.totalOrders || 0 }}</p>
      </div>
      <i class="fas fa-box-open text-yellow-500 text-4xl"></i>
    </div>
  </div>

  <!-- Paid Orders -->
  <div class="bg-gradient-to-r from-green-100 to-green-50 shadow-md rounded-2xl p-6 border-l-8 border-green-500 hover:shadow-lg transition-all duration-300">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-gray-600 text-sm uppercase font-semibold">Paid Orders</h3>
        <p class="text-4xl font-bold text-green-600 mt-1">{{ summary?.totalPaid || 0 }}</p>
      </div>
      <i class="fas fa-check-circle text-green-500 text-4xl"></i>
    </div>
  </div>

  <!-- Unpaid Orders -->
  <div class="bg-gradient-to-r from-red-100 to-red-50 shadow-md rounded-2xl p-6 border-l-8 border-red-500 hover:shadow-lg transition-all duration-300">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-gray-600 text-sm uppercase font-semibold">Unpaid Orders</h3>
        <p class="text-4xl font-bold text-red-600 mt-1">{{ summary?.totalUnpaid || 0 }}</p>
      </div>
      <i class="fas fa-times-circle text-red-500 text-4xl"></i>
    </div>
  </div>

  <!-- Total Labour Charges -->
  <div class="bg-gradient-to-r from-blue-100 to-blue-50 shadow-md rounded-2xl p-6 border-l-8 border-blue-500 hover:shadow-lg transition-all duration-300">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-gray-600 text-sm uppercase font-semibold">Total Labour Charges</h3>
        <p class="text-3xl font-bold text-blue-600 mt-1">
          ₹{{ summary?.totalLabourCharges | number: '1.2-2' }}
        </p>
      </div>
      <i class="fas fa-coins text-blue-500 text-4xl"></i>
    </div>
  </div>

  <!-- Paid Labour -->
  <div class="bg-gradient-to-r from-green-100 to-green-50 shadow-md rounded-2xl p-6 border-l-8 border-green-400 hover:shadow-lg transition-all duration-300">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-gray-600 text-sm uppercase font-semibold">Paid Labour</h3>
        <p class="text-3xl font-bold text-green-500 mt-1">
          ₹{{ summary?.paidLabourCharges | number: '1.2-2' }}
        </p>
      </div>
      <i class="fas fa-hand-holding-usd text-green-500 text-4xl"></i>
    </div>
  </div>

  <!-- Unpaid Labour -->
  <div class="bg-gradient-to-r from-red-100 to-red-50 shadow-md rounded-2xl p-6 border-l-8 border-red-400 hover:shadow-lg transition-all duration-300">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-gray-600 text-sm uppercase font-semibold">Unpaid Labour</h3>
        <p class="text-3xl font-bold text-red-500 mt-1">
          ₹{{ summary?.unpaidLabourCharges | number: '1.2-2' }}
        </p>
      </div>
      <i class="fas fa-exclamation-circle text-red-500 text-4xl"></i>
    </div>
  </div>

</div>

<!-- Payment Breakdown -->
<div class="mt-8 bg-white shadow-lg rounded-2xl p-8">
  <h2 class="text-xl font-bold text-gray-800 mb-6 border-b pb-2 flex items-center gap-2">
    <i class="fas fa-chart-pie text-blue-500"></i> Payment Breakdown
  </h2>

  <div class="flex flex-col sm:flex-row justify-around items-center gap-6">

    <!-- Paid -->
    <div class="text-center w-full sm:w-1/3">
      <p class="text-sm text-gray-500 mb-2">Paid (%)</p>
      <p class="text-3xl font-bold text-green-600">
        {{
          (summary?.totalOrders
            ? (summary.totalPaid / summary.totalOrders * 100)
            : 0) | number: '1.0-1'
        }}%
      </p>
      <div class="w-full bg-gray-200 rounded-full h-3 mt-3">
        <div
          class="h-3 rounded-full bg-green-500 transition-all duration-500"
          [style.width]="(summary?.totalOrders ? (summary.totalPaid / summary.totalOrders * 100) : 0) + '%'">
        </div>
      </div>
    </div>

    <!-- Unpaid -->
    <div class="text-center w-full sm:w-1/3">
      <p class="text-sm text-gray-500 mb-2">Unpaid (%)</p>
      <p class="text-3xl font-bold text-red-600">
        {{
          (summary?.totalOrders
            ? (summary.totalUnpaid / summary.totalOrders * 100)
            : 0) | number: '1.0-1'
        }}%
      </p>
      <div class="w-full bg-gray-200 rounded-full h-3 mt-3">
        <div
          class="h-3 rounded-full bg-red-500 transition-all duration-500"
          [style.width]="(summary?.totalOrders ? (summary.totalUnpaid / summary.totalOrders * 100) : 0) + '%'">
        </div>
      </div>
    </div>

  </div>
</div>
